// import { Component, OnInit } from "@angular/core";
// import { FormBuilder, FormGroup, Validators } from "@angular/forms";
// import { ActivatedRoute, Router } from "@angular/router";
// import { CommonService } from "src/app/services/common.service";
// import { InventoryService } from "../inventory.service";

// @Component({
//   selector: "app-purchase-order-form",
//   templateUrl: "./purchase-order-form.component.html",
//   styleUrls: ["./purchase-order-form.component.sass"],
// })
// export class PurchaseOrderFormComponent implements OnInit {
//   optionsVisibility = {};
//   category = "";
//   categories = [];
//   products: [];
//   selectedProduct = {};
//   isValid = false;
//   submitted = false;
//   addInventoryForm: FormGroup;

//   private inventoryData = {
//     categoryId: "",
//     inventoryItemId: "",
//     name: "",
//     deliveryPickupAddress: "",
//     note: "",
//     // "latitude": "",
//     // "longitude": "",
//     orderQut: null,
//   };

//   constructor(
//     private _fb: FormBuilder,
//     private route: ActivatedRoute,
//     private router: Router,
//     private api: InventoryService,
//     private commonService: CommonService
//   ) {}

//   ngOnInit() {
//     this.route.params.subscribe(() => {
//       // this.category = this.route.snapshot.params.category;
//       this.getCategories();

//       this.addInventoryForm = this._fb.group({
//         categoryId: ["", [Validators.required]],
//         inventoryItemId: ["", [Validators.required, Validators.minLength(2)]],
//         name: ["", Validators.required],
//         deliveryPickupAddress: [
//           "",
//           [Validators.required, Validators.minLength(2)],
//         ],
//         orderQut: [null, [Validators.required, Validators.min(0)]],
//         note: [""],
//       });
//     });
//   }

//   get f() {
//     return this.addInventoryForm.controls;
//   }

//   getCategories() {
//     this.api.getCategories().subscribe(
//       (result: any) => {
//         const response = result.data;
//         if (response.items) {
//           const  temp = response.items;
//           this.categories = temp.filter((e) => e.route != 'raw_materials')
//           const selectedCategory = response.items[0];
//           this.addInventoryForm.patchValue({
//             categoryId: selectedCategory._id, // Set the default category id here
//           });
//           this.inventoryData.categoryId = selectedCategory._id;
//           this.handleProductSearch("");
//         }
//       },
//       (error: any) => {
//         // this.commonService.toast(error.error.message, 'Error');
//       }
//     );
//   }

//   handleOptionVisibility(event: any, isShow: boolean) {
//     const name = event.target.name;

//     setTimeout(() => {
//       this.optionsVisibility[name] = isShow;
//     }, 500);
//   }

//   handleProductSearch(event: any) {
//     const str = event ? event.target.value : "";

//     const formData = this.addInventoryForm.value;
//     const data = {
//       search: str,
//       categoryId: formData.categoryId,
//     };

//     this.api.getInventories(data).subscribe(
//       (result: any) => {
//         this.products = result.data.items;
//         // this.commonService.toast(result.message, "Success");
//       },
//       (error: any) => {
//         // this.commonService.toast(error.error.message, "Error");
//       }
//     );

//     this.addInventoryForm.patchValue({
//       inventoryItemId: "",
//     });
//     this.selectedProduct = {};
//   }

//   handleProductSelect(item: any) {
//     this.selectedProduct = item;

//     this.addInventoryForm.patchValue({
//       inventoryItemId: item._id,
//     });
//   }

//   handleSubmit() {
//     this.submitted = true;

//     if (this.addInventoryForm.valid) {
//       const formData = this.addInventoryForm.value;

//       this.api.addPurchaseOrder(formData).subscribe(
//         (result: any) => {
//           this.addInventoryForm.patchValue(this.inventoryData);
//           this.commonService.toast(result.message, "Success");
//           this.submitted = false;
//           this.router.navigate(["/Inventory/PO/list/create_po"]);
//         },
//         (error: any) => {
//           this.commonService.toast(error.error.message, "Error");
//         }
//       );
//     }
//   }
// }
import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators, FormArray } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { CommonService } from "src/app/services/common.service";
import { InventoryService } from "../inventory.service";
interface OrderItem {
  categoryId: string;
  inventoryItemId: string;
  orderQut: number;
}

interface InternalOrderPayload {
  name: string;
  deliveryPickupAddress: string;
  note?: string;
  purchaseItems: OrderItem[];
}
@Component({
  selector: "app-purchase-order-form",
  templateUrl: "./purchase-order-form.component.html",
  styleUrls: ["./purchase-order-form.component.sass"],
})
export class PurchaseOrderFormComponent implements OnInit {
  optionsVisibility: any = {};
  categories = [];
  productsByIndex: any = {}; // Stores products for each item index
  selectedProducts: any = {}; // Stores selected product for each item index
  submitted = false;
  addInventoryForm: FormGroup;

  constructor(
    private _fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private api: InventoryService,
    private commonService: CommonService
  ) { }

  ngOnInit() {
    this.route.params.subscribe(() => {
      this.getCategories();

      this.addInventoryForm = this._fb.group({
        name: ["", Validators.required],
        deliveryPickupAddress: ["", [Validators.required, Validators.minLength(2)]],
        note: [""],
        items: this._fb.array([this.createItemFormGroup()])
      });
    });
  }

  // Convenience getters for easy access in template
  get f() {
    return this.addInventoryForm.controls;
  }

  get itemsFormArray() {
    return this.addInventoryForm.get('items') as FormArray;
  }

  createItemFormGroup(): FormGroup {
    return this._fb.group({
      categoryId: ["", Validators.required],
      productName: [""],
      inventoryItemId: ["", Validators.required],
      orderQut: [null, [Validators.required, Validators.min(1)]]
    });
  }

  addItem() {
    this.itemsFormArray.push(this.createItemFormGroup());
  }

  removeItem(index: number) {
    this.itemsFormArray.removeAt(index);
    // Clean up related data
    delete this.productsByIndex[index];
    delete this.selectedProducts[index];
    delete this.optionsVisibility[index];
  }

  getCategories() {
    this.api.getCategories().subscribe(
      (result: any) => {
        const response = result.data;
        if (response.items) {
          this.categories = response.items.filter((e: any) => e.route != 'raw_materials');
          // Set default category for first item if available
          if (this.categories.length > 0 && this.itemsFormArray.length > 0) {
            this.itemsFormArray.at(0).patchValue({
              categoryId: this.categories[0]._id
            });
            this.handleProductSearch('', 0);
          }
        }
      },
      (error: any) => {
        this.commonService.toast(error.error.message, 'Error');
      }
    );
  }

  handleOptionVisibility(event: any, isShow: boolean, index: number) {
    if (!this.optionsVisibility[index]) {
      this.optionsVisibility[index] = {};
    }
    setTimeout(() => {
      this.optionsVisibility[index].product = isShow;
    }, 200);
  }

  handleProductSearch(event: any, index: number) {
    const str = event ? event.target.value : "";
    const itemGroup = this.itemsFormArray.at(index);
    const categoryId = itemGroup.get('categoryId').value;

    if (!categoryId) {
      this.commonService.toast('Please select a category first', 'Warning');
      return;
    }

    const data = {
      search: str,
      categoryId: categoryId,
    };

    this.api.getInventories(data).subscribe(
      (result: any) => {
        this.productsByIndex[index] = result.data.items;
      },
      (error: any) => {
        this.commonService.toast(error.error.message, "Error");
      }
    );

    // Reset product selection if searching
    if (str) {
      itemGroup.patchValue({
        inventoryItemId: "",
        productName: str
      });
      this.selectedProducts[index] = null;
    }
  }

  handleProductSelect(item: any, index: number) {
    this.selectedProducts[index] = item;
    const itemGroup = this.itemsFormArray.at(index);

    itemGroup.patchValue({
      inventoryItemId: item._id,
      productName: item.itemName
    });

    // Hide options after selection
    if (this.optionsVisibility[index]) {
      this.optionsVisibility[index].product = false;
    }
  }

  handleSubmit() {
    this.submitted = true;

    if (this.addInventoryForm.valid) {
      const formData = this.addInventoryForm.value;

      // Create properly typed payload
      const payload: InternalOrderPayload = {
        name: formData.name,
        deliveryPickupAddress: formData.deliveryPickupAddress,
        note: formData.note || undefined, // Make optional if empty
        purchaseItems: formData.items.map((item: any) => ({
          categoryId: item.categoryId,
          inventoryItemId: item.inventoryItemId,
          orderQut: item.orderQut
        }))
      };

      this.api.addPurchaseOrder(payload).subscribe(
        (result: any) => {
          this.commonService.toast(result.message, "Success");
          this.submitted = false;
          this.router.navigate(["/Inventory/PO/list/create_po"]);
        },
        (error: any) => {
          this.commonService.toast(error.error.message, "Error");
        }
      );
    } else {
      this.commonService.toast('Please fill all required fields correctly', 'Warning');
    }
  }
}